module.exports = __webpack_public_path__ + "img/about1.c71f8395.jpg";